import {InjectionToken} from '@angular/core';

import {PathResolver} from '../interfaces/path-resolver';

export const PATH_RESOLVER_TOKEN = new InjectionToken<PathResolver[]>('Connector#PathResolver');
